import { resolveComponent } from 'vue';import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-240ebc85"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "time-box"
};
const _hoisted_2 = {
  class: "size24"
};
const _hoisted_3 = {
  class: "size14"
};
const _hoisted_4 = {
  class: "menu scroll_bar"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "child-title"
};
const _hoisted_8 = {
  key: 0,
  class: "tips-num"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "display-start"
};
const _hoisted_11 = {
  class: "child-title"
};
const _hoisted_12 = {
  key: 0,
  class: "tips-num"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  return _ctx.token ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.getSideStatus ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.showHous), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($data.showDay), 1), _createElementVNode("span", null, "星期" + _toDisplayString($data.showWeek), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSideMenuArr, menu => {
    return _openBlock(), _createElementBlock("div", {
      key: menu.name,
      class: "menu-content"
    }, [_createElementVNode("div", _hoisted_5, _toDisplayString(menu.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, group => {
      return _openBlock(), _createElementBlock("div", {
        key: group.name,
        class: _normalizeClass({
          actived: $options.modifyActived(group),
          'group-box': !$options.showChildMenu(group)
        }),
        onClick: $event => $options.handleSelect(group)
      }, [_createElementVNode("div", {
        class: _normalizeClass(["display-start", {
          'group-box': $options.showChildMenu(group)
        }])
      }, [group.meta?.icon ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        "icon-class": group.meta?.icon
      }, null, 8, ["icon-class"])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_7, _toDisplayString(group.meta?.title), 1)], 2), _ctx.sideMenuOther[group.name]?.toDoNum ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($options.maxNum(_ctx.sideMenuOther[group.name]?.toDoNum)), 1)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, childGroup => {
        return _openBlock(), _createElementBlock(_Fragment, null, [childGroup.meta?.menuShow ? (_openBlock(), _createElementBlock("div", {
          key: childGroup.name,
          class: _normalizeClass(["child-box", $options.modifyActived(childGroup) ? 'actived' : '']),
          onClick: _withModifiers($event => $options.handleSelect(childGroup), ["stop"])
        }, [_createElementVNode("div", _hoisted_10, [childGroup.meta?.icon ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          "icon-class": childGroup.meta?.icon
        }, null, 8, ["icon-class"])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_11, _toDisplayString(childGroup.meta?.title), 1)]), _ctx.sideMenuOther[childGroup.name]?.toDoNum ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($options.maxNum(_ctx.sideMenuOther[childGroup.name]?.toDoNum)), 1)) : _createCommentVNode("", true)], 10, _hoisted_9)) : _createCommentVNode("", true)], 64);
      }), 256))], 512), [[_vShow, group.children && group.children.length > 0 && $options.childActived(group)]])], 10, _hoisted_6);
    }), 128))]);
  }), 128))])], 64)) : _createCommentVNode("", true);
}